import Cookies from 'js-cookie';
import { getMyMessageList, getInfo } from "@/api/system/config/webSet";
var state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  webInfo: null,
  messageIndex: null
};
var mutations = {
  TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
    state.device = device;
  },
  SET_SIZE: function SET_SIZE(state, size) {
    state.size = size;
    Cookies.set('size', size);
  },
  SET_WEB_INFO: function SET_WEB_INFO(state, res) {
    state.webInfo = res;
  }
};
var actions = {
  toggleSideBar: function toggleSideBar(_ref) {
    var commit = _ref.commit;
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar: function closeSideBar(_ref2, _ref3) {
    var commit = _ref2.commit;
    var withoutAnimation = _ref3.withoutAnimation;
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice: function toggleDevice(_ref4, device) {
    var commit = _ref4.commit;
    commit('TOGGLE_DEVICE', device);
  },
  setSize: function setSize(_ref5, size) {
    var commit = _ref5.commit;
    commit('SET_SIZE', size);
  },
  setTitle: function setTitle(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve, reject) {
      getInfo().then(function (res) {
        // console.log('title',res.data.web_content)
        commit('SET_WEB_INFO', res.data.web_content);
        // document.title = res.data.web_content.web_name
        resolve(res.data.web_content);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
export default {
  //添加了namespaced: true,  调用的时候需要添加具名空间  例如this.$store.dispatch("app/setTitle")
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};